import ViewGroupsPage from "components/viewGroups/ViewGroups.component"

const ViewGroups = () => {
  return (
    <ViewGroupsPage />
  )
}

export default ViewGroups
